import { render } from "./Submission.vue?vue&type=template&id=7aebfcf4&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"

import "./Submission.vue?vue&type=style&index=0&id=7aebfcf4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aebfcf4"]])

export default __exports__